const getKeyByValue = (object, value) => Object.keys(object).find(key => object[key] === value)

const pipe = (...fns) => (x) => fns.reduce((prev, func) => func(prev), x)

const promisePipe = (...fns) => async (x) => fns.reduce(async (prev, next) => await next(await prev), Promise.resolve(x))

const compose = (...fns) => data => fns.reduceRight((acc, fn) => fn(acc), data)

const composePromise = (...fns) => async (...data) => {
  return await fns.reduceRight(async (acc, x) => {
    return await x(await acc)
  }, data.length === 1 ? Promise.resolve(data[0]) : Promise.resolve(data))
}

const logMe = (x) => {
  console.log(x)
  return x
}

const objectSafe = (state, thing, key) => typeof state[thing] === 'object' ? state[thing][key] : state[thing]

const sumReducer = (acc, sq) => acc + sq

const swapKeysWithValues = (object) => Object.keys(object).reduce((acc, key) => {
  acc[object[key]] = key

  return acc
}, {})

export { getKeyByValue, pipe, promisePipe, compose, composePromise, logMe, objectSafe, sumReducer, swapKeysWithValues }
